<template>
  <div>
    <slot />

    <slot
      v-if="mediaLoaded"
      name="ctaBannerTop"
    />

    <XLazyMedia
      type="video"
      :videoOptions="playerOptions"
      @mediaLoaded="emitMediaLoaded"
    />

    <slot
      v-if="mediaLoaded"
      name="ctaBannerBottom"
    />

    <slot name="footer" />
  </div>
</template>

<script>
import 'video.js/dist/video-js.css'

import { videoPlayer } from 'vue-video-player'

import Mixin from './mixin'

export default {
  mixins: [Mixin],

  components: {
    'XVideoPlayer': videoPlayer
  },

  props: {
    url: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      playerOptions: {
        language: 'es',
        sources: [{
          type: 'video/mp4',
          src: this.url
        }],
        poster: this.thumbnail
      }
    }
  }
}
</script>
